import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { VerifyGovernmentIdRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { VerifyGovernmentIdResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const verifyGovernmentId = (request: VerifyGovernmentIdRequest, options?: CashRequestOptions) =>
  post<VerifyGovernmentIdRequest, VerifyGovernmentIdResponse>('/2.0/cash/verify-government-id', request, {
    ...options,
    rejectOnError: true,
  })
